import { Component, OnInit } from '@angular/core';
import { debounce } from 'lodash';

import { environment } from '../../../environments/environment';
import { Credential, NewCredential } from '../../helpers/user';

import { UserService } from '../../services/user.service';

@Component({
    selector: 'kd-credentials-modal',
    templateUrl: './credentials-modal.component.html',
    styleUrls: ['./credentials-modal.component.scss']
})
export class CredentialsModalComponent implements OnInit {

    credentials: Array<Credential> = [];
    loader = false;
    modalOpen = false;
    newCredential: NewCredential = {
        key: null,
        value: ''
    };
    onUpdate: (credential: Credential) => void = debounce(this.updateCredential, environment.debounceInput);
    options: Array<string> = [];

    constructor(
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.userService.getCredentialsOpen().subscribe(() => {
            this.modalOpen = true;
            this.initModal(true);
        });
    }

    async add(): Promise<void> {
        this.loader = true;

        await this.userService.addCredential(this.newCredential);
        this.initModal(true);

        this.loader = false;
    }

    private initModal(resetNew: boolean = false): void {
        this.credentials = this.userService.getCredentials();
        this.options = this.userService.getCredentialOptions();

        if (resetNew) {
            this.newCredential = {
                key: this.options.length ? this.options[0] : null,
                value: ''
            };
        }
    }

    async remove(credential: Credential): Promise<void> {
        this.loader = true;

        await this.userService.removeCredential(credential);
        this.initModal();

        this.loader = false;
    }

    private async updateCredential(credential: Credential): Promise<void> {
        this.loader = true;
        await this.userService.updateCredential(credential);
        this.loader = false;
    }
}
